import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import Header from '../../components/Header';
import MenuDrawer from '../../components/MenuDrawer';
import QrCodeTextButton from '../../components/atoms/QrCodeTextButton';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import { isAuthenticated, sendLogin } from '../../auth/Auth';
import { downloadQrCode } from '../../actions/Shop';

const styles = {
  root: {
    backgroundColor: '#e0e0e0',
    flexGrow: 1,
    width: '100%'
  },
  pageTitileDiv: {
    paddingLeft: 20,
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff'
  },
  mainPaper: {
    position: 'relative',
    margin: 20
  },
  detailTable: {
    width: 'auto'
  },
  tableCellItem: {
    border: '2px solid #ffffff'
  },
  tableCellData: {
    border: '2px solid #ffffff'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account,
      name: state.loginInfo.name
    }),
    dispatch => ({
      actions: bindActionCreators({ downloadQrCode }, dispatch)
    })
  ),
  setPropTypes(propTypes),
  withState('openDrawer', 'updateOpenDrawer', false),
  withState('openProgress', 'updateOpenProgress', false),
  withState('loading', 'updateLoading', false),
  withState('resultMessage', 'setResultMessage', ''),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    }
  }),
  lifecycle({
    componentDidMount() {
      isAuthenticated(this.props);
    }
  })
);

const Main = enhance(
  ({
    classes,
    actions,
    checkSession,
    account,
    name,
    openDrawer,
    updateOpenDrawer,
    loading,
    updateLoading,
    openProgress,
    updateOpenProgress,
    resultMessage,
    setResultMessage
  }) => {
    // function add text (Water-Mark) to image qr code
    const addWaterMark = async blob => {
      const canvas = await new Promise(resolve => {
        const objectURL = URL.createObjectURL(blob);
        const c = document.createElement('canvas');
        c.width = 390;
        c.height = 390;
        const ctx = c.getContext('2d');
        const img = new Image();

        img.onload = () => {
          ctx.drawImage(img, 0, 0);
          ctx.fillStyle = 'red';
          ctx.textBaseline = 'bottom';
          ctx.font = "18px 'Roboto', 'Helvetica', 'Arial', sans-serif";
          ctx.fillText('ごちめしアプリで読み込んでください', 42, 376);
          resolve(c);
        };
        img.src = objectURL;
        console.log('objectURL', objectURL);
      });

      return new Promise(resolve => {
        canvas.toBlob(
          newblob => {
            resolve(newblob);
          },
          'image/jpeg',
          1
        );
      });
    };

    const downloadQrBlob = async (blob, fileName) => {
      const newBlob = await addWaterMark(blob);
      if (window.navigator.msSaveOrOpenBlob) {
        // for IE,Edge
        window.navigator.msSaveOrOpenBlob(newBlob, fileName);
      } else {
        // for chrome, firefox
        const url = URL.createObjectURL(
          new Blob([newBlob], { type: 'image/jpeg' })
        );
        const linkEl = document.createElement('a');
        linkEl.href = url;
        linkEl.setAttribute('download', fileName);
        document.body.appendChild(linkEl);
        linkEl.click();

        linkEl.parentNode.removeChild(linkEl);
        setTimeout(() => {
          URL.revokeObjectURL(url);
        }, 1000);
      }
    };

    const qrCodeAction = id => {
      updateLoading(true);
      updateOpenProgress(true);
      actions.downloadQrCode(id).then(response => {
        checkSession(response);
        if (response.type === 'DOWNLOAD_QRCODE_SUCCESS') {
          updateOpenProgress(false);
          setResultMessage('');
          updateLoading(false);
          downloadQrBlob(response.payload, 'qrcode.jpg');
        } else {
          setResultMessage('QRコードダウンロードに失敗しました。');
          updateLoading(false);
        }
      });
    };

    const progressOkAction = () => {
      updateOpenProgress(false);
    };

    return (
      <div className={classes.root}>
        <Header
          name={name}
          onMenuClick={() => {
            updateOpenDrawer(true);
          }}
        />
        <Drawer
          open={openDrawer}
          anchor="left"
          onClose={() => {
            updateOpenDrawer(false);
          }}
        >
          <div tabIndex={0} role="button">
            <MenuDrawer account={account} />
          </div>
        </Drawer>
        <div className={classes.pageTitileDiv}>
          <Typography variant="h6" color="textSecondary">
            QRコード発行
          </Typography>
          <Typography color="textSecondary">
            店舗に設置するQRコードをダウンロードできます。
          </Typography>
        </div>
        <Paper className={classes.mainPaper} elevation={1}>
          <Table className={classes.detailTable}>
            <TableRow>
              <TableCell className={classes.tableCellItem}>
                QRコードダウンロード
              </TableCell>
              <TableCell className={classes.tableCellData}>
                <QrCodeTextButton
                  id={account.shopId}
                  onClickAction={qrCodeAction}
                />
              </TableCell>
            </TableRow>
          </Table>
        </Paper>
        <ProgressDialog
          openProgress={openProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
